export var Tokens;
(function (Tokens) {
    Tokens["ILLEGAL"] = "ILLEGAL";
    Tokens["EOF"] = "EOF";
    Tokens["NL"] = "\n";
    Tokens["SPACE"] = " ";
    Tokens["UNDERSCORE"] = "_";
    Tokens["DOLLAR"] = "$";
    Tokens["ATSIGN"] = "@";
    Tokens["CARET"] = "^";
    Tokens["HASH"] = "#";
    Tokens["TILDE"] = "~";
    Tokens["AMPERSAND"] = "&";
    // Identifiers + literals,
    Tokens["IDENT"] = "IDENT";
    Tokens["COMMENT"] = "COMMENT";
    Tokens["STRING"] = "STRING";
    Tokens["NUMBER"] = "NUMBER";
    Tokens["FLOAT"] = "FLOAT";
    Tokens["CTLOP"] = "CTLOP";
    Tokens["BYTES"] = "BYTES";
    Tokens["HEX"] = "HEX";
    Tokens["BASE64"] = "BASE64";
    // Operators,
    Tokens["ASSIGN"] = "=";
    Tokens["ARROWMAP"] = "=>";
    Tokens["TCHOICE"] = "/";
    Tokens["GCHOICE"] = "//";
    Tokens["TCHOICEALT"] = "/=";
    Tokens["GCHOICEALT"] = "//=";
    Tokens["PLUS"] = "+";
    Tokens["MINUS"] = "-";
    Tokens["QUEST"] = "?";
    Tokens["ASTERISK"] = "*";
    // Ranges,
    Tokens["INCLRANGE"] = "..";
    Tokens["EXCLRANGE"] = "...";
    // Delimiters,
    Tokens["COMMA"] = ",";
    Tokens["DOT"] = ".";
    Tokens["COLON"] = ":";
    Tokens["SEMICOLON"] = ";";
    Tokens["LPAREN"] = "(";
    Tokens["RPAREN"] = ")";
    Tokens["LBRACE"] = "{";
    Tokens["RBRACE"] = "}";
    Tokens["LBRACK"] = "[";
    Tokens["RBRACK"] = "]";
    Tokens["LT"] = "<";
    Tokens["GT"] = ">";
    Tokens["QUOT"] = "\"";
})(Tokens || (Tokens = {}));
const reverseTokens = Object.entries(Tokens).reduce((acc, [key, value]) => {
    acc[value] = key;
    return acc;
}, {});
export class Token {
    type;
    literal;
    comments;
    whitespace;
    constructor(type, literal, comments = [], whitespace = "") {
        this.type = type;
        this.literal = literal;
        this.comments = comments;
        this.whitespace = whitespace;
    }
    serialize() {
        let output = "";
        for (const comment of this.comments) {
            output += comment.serialize();
        }
        output += this.whitespace;
        switch (this.type) {
            case Tokens.IDENT:
            case Tokens.COMMENT:
            case Tokens.NUMBER:
            case Tokens.FLOAT:
                output += this.literal;
                break;
            case Tokens.STRING:
                output += '"' + this.literal + '"';
                break;
            case Tokens.CTLOP:
                output += "." + this.literal;
                break;
            case Tokens.BYTES:
                output += "'" + this.literal + "'";
                break;
            case Tokens.HEX:
                output += "h'" + this.literal + "'";
                break;
            case Tokens.BASE64:
                output += "b64'" + this.literal + "'";
                break;
            case Tokens.EOF:
                break;
            default:
                output += this.type.valueOf();
        }
        return output;
    }
    startWithSpaces() {
        return this.whitespace !== "" || this.comments.length > 0;
    }
    toString(indent = 0) {
        const indentStr = "  ".repeat(indent);
        const res = [
            `${indentStr}${this.constructor.name}: ${reverseTokens[this.type]} (${this.type})`
        ];
        if (this.whitespace !== "") {
            res.push("  ".repeat(indent + 1) + `whitespaces: ${this.whitespace.length}`);
        }
        if (this.literal !== "") {
            res.push("  ".repeat(indent + 1) + `literal: ${this.literal}`);
        }
        for (const comment of this.comments) {
            res.push(comment.toString(indent + 1));
        }
        return res.join("\n");
    }
    toJSON() {
        return {
            type: this.type,
            literal: this.literal,
            comments: this.comments?.map(c => c.toJSON()),
            whitespace: this.whitespace
        };
    }
}
//# sourceMappingURL=tokens.js.map